import React from 'react';
import { Hero } from '../components/Hero';
import { OpeningHook } from '../components/OpeningHook';
import { Problem } from '../components/Problem';
import { WhyDidntWork } from '../components/WhyDidntWork';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { ForWhom } from '../components/ForWhom';
import { HowItWorks } from '../components/HowItWorks';
import { Proof } from '../components/Proof';
import { FAQ } from '../components/FAQ';
import { Offer } from '../components/Offer';
import { Footer } from '../components/Footer';
export function Landing() {
  return <main className="min-h-screen bg-heritage-cream font-sans text-heritage-coffee selection:bg-heritage-terracotta/20" data-id="element-209">
      <Hero data-id="element-210" />
      <OpeningHook data-id="element-211" />
      <Problem data-id="element-212" />
      <WhyDidntWork data-id="element-213" />
      <UniqueMechanism data-id="element-214" />
      <WhatYouGet data-id="element-215" />
      <ForWhom data-id="element-216" />
      <HowItWorks data-id="element-217" />
      <Proof data-id="element-218" />
      <FAQ data-id="element-219" />
      <Offer data-id="element-220" />
      <Footer data-id="element-221" />
    </main>;
}